// extracted by mini-css-extract-plugin
module.exports = {"box":"box-1HT7Mc-Z","hyh":"hyh-3ibalAde","show":"show-3ZzVbA0h","hide":"hide-kgDXycnS"};